module.exports = __webpack_public_path__ + "img/drawing_renwu.4f2364c1.png";